import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { imgBaseUrl } from "../../api/api";
import "./StudentCharacterCertificate1.css";

const StudentCharacterCertificateManual = forwardRef((props, ref) => {
  const [setting, setSetting] = useState({});
  const [form, setForm] = useState({
    cert_no: "",
    date: new Date().toLocaleDateString(),
    name: "",
    relation: "S/o",
    parent_name: "",
    reg_no: "",
    course: "",
    session: "",
    conduct: "GOOD",
    place: "",
  });

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? "{}"));
  }, []);

  useImperativeHandle(ref, () => ({
    getPrintData: () => ({ form, setting }),
  }));

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const logoUrl = imgBaseUrl + setting?.logo_img;

  return (
    <div
      className="cc-outer"
      id="PrintDivManual"
      style={{ "--cc-logo-url": `url(${logoUrl})` }}
    >
      <div className="cc-inner">
        <div className="cc-corner cc-corner-tl" />
        <div className="cc-corner cc-corner-tr" />
        <div className="cc-corner cc-corner-bl" />
        <div className="cc-corner cc-corner-br" />

        <div className="cc-header">
          <div className="cc-logo-box">
            <img src={logoUrl} alt="logo" />
          </div>
          <div className="cc-header-text">
            <h1 className="cc-inst-name">{setting?.name}</h1>
            <p className="cc-inst-meta">
              {setting?.village}, {setting?.district}, {setting?.state} -{" "}
              {setting?.pin_code}
            </p>
            <p className="cc-inst-meta">
              Mobile: {setting?.mobile}
              {setting?.secondary_mobile &&
                `, ${setting?.secondary_mobile}`}{" "}
              &nbsp;•&nbsp; {setting?.email}
            </p>
          </div>
        </div>

        <div className="cc-title-block">
          <p className="cc-eyebrow">This certifies that</p>
          <h2 className="cc-title">Character Certificate</h2>
          <div className="cc-title-rule">
            <span className="line" />
            <span className="dot" />
            <span className="line" />
          </div>
        </div>

        <div className="cc-meta-row">
          <div>
            Certificate No:{" "}
            <input
              className="cc-blank"
              style={{
                minWidth: "100px",
                fontSize: "12px",
                fontStyle: "normal",
              }}
              name="cert_no"
              value={form.cert_no}
              onChange={handleChange}
            />
          </div>
          <div>
            Date of Issue:{" "}
            <input
              className="cc-blank"
              style={{
                minWidth: "110px",
                fontSize: "12px",
                fontStyle: "normal",
              }}
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="cc-body">
          <p>
            This is to certify that Mr./Ms.{" "}
            <input
              className="cc-blank"
              style={{ minWidth: "200px" }}
              name="name"
              value={form.name}
              onChange={handleChange}
              placeholder="Student Name"
            />{" "}
            <select
              className="cc-blank"
              style={{ minWidth: "60px" }}
              name="relation"
              value={form.relation}
              onChange={handleChange}
            >
              <option value="S/o">S/o</option>
              <option value="D/o">D/o</option>
            </select>{" "}
            <input
              className="cc-blank"
              style={{ minWidth: "200px" }}
              name="parent_name"
              value={form.parent_name}
              onChange={handleChange}
              placeholder="Parent Name"
            />{" "}
            was a bonafide student of <b>{setting?.name}</b>, bearing
            Registration No.{" "}
            <input
              className="cc-blank"
              style={{ minWidth: "120px" }}
              name="reg_no"
              value={form.reg_no}
              onChange={handleChange}
              placeholder="Reg. No."
            />
            .
          </p>
          <p>
            He/She studied in{" "}
            <input
              className="cc-blank"
              style={{ minWidth: "180px" }}
              name="course"
              value={form.course}
              onChange={handleChange}
              placeholder="Course"
            />{" "}
            course during the academic session{" "}
            <input
              className="cc-blank"
              style={{ minWidth: "120px" }}
              name="session"
              value={form.session}
              onChange={handleChange}
              placeholder="2024-25"
            />
            .
          </p>
          <p>
            During his/her stay in the institute, his/her conduct and character
            were found to be{" "}
            <input
              className="cc-blank"
              style={{ minWidth: "100px" }}
              name="conduct"
              value={form.conduct}
              onChange={handleChange}
            />
            . We wish him/her success and a bright future ahead.
          </p>
        </div>

        <div className="cc-footer">
          <div className="cc-footer-col">
            <div>
              Place:{" "}
              <input
                className="cc-blank"
                style={{
                  minWidth: "130px",
                  fontSize: "12px",
                  fontStyle: "normal",
                }}
                name="place"
                value={form.place}
                onChange={handleChange}
                placeholder="Place"
              />
            </div>
          </div>
          <div className="cc-footer-col">
            <div className="cc-line">Principal Seal & Signature</div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default StudentCharacterCertificateManual;
